// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BackgroundVideo_wrapper__1ZtPv","overlay":"BackgroundVideo_overlay__0BwEk","fadeIn":"BackgroundVideo_fadeIn__Fpmvw"};